import baseapi from "./../baseAPI";
import {successMesg, errorMesg} from "./../../Pages/Toaster";
const imagepath = "https://apiv3.edustack360.com/uploads/profile/";

export const saveProfileAPI = async (formdata, setBtnLoader) =>
{
    setBtnLoader(true);

    try
    {
        const response = await baseapi.post("/api/team/profile/update", formdata, {headers: {'Content-Type': 'multipart/form-data'}});

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Profile has been updated successfully");

        }
        else
        {
            errorMesg("Profile has not been updated. Please try again!!!");
        }
        
        setBtnLoader(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setBtnLoader(false);
        errorMesg("Profile has not been updated. Please try again!!!");
    };
}

export const getProfileDataAPI = async (setName, setEmail, setContact, setUsername, setAddress, setCity, setState, setPincode, setImage) =>
{

    try
    {
        const response = await baseapi.get("/api/team/profile");

        console.log("Data got successfully", response.data.profiledata);

        setName(response.data.profiledata.name); 
        setEmail(response.data.profiledata.email);
        setContact(response.data.profiledata.contact);
        setUsername(response.data.profiledata.username);
        setAddress(response.data.profiledata.address);
        setCity(response.data.profiledata.city);
        setState(response.data.profiledata.state);
        setPincode(response.data.profiledata.pincode);
        setImage(imagepath + response.data.profiledata.image);

        
    }
    catch(error) 
    {
        console.error("Error in user list:", error);
    };
}